import { PAGINATION } from '@App/const/pagination'
import { PaginationInfo } from '@Entities/pagination'

export const calcNumPages = (count: number, limit = 10, currentPage = 1, refined?: boolean): PaginationInfo => ({
    currentPage,
    lastPage: count !== 0 ? Math.ceil(count / limit) : 1,
    cappedLastPage: count !== 0 ? Math.min(Math.ceil(count / limit), Math.ceil(PAGINATION.paginationLimit / limit)) : 1,
    refined,
})
